import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (retryCount, error) => {
        // Suboptimal solution, should be revisited later in a separate PRD.
        if (error != null && 'message' in error) {
          switch (error.message) {
            case 'You are not authorized to perform that action':
            case 'You are sending too many requests. Try again later.':
            case 'Invalid Response Encoding':
              return false

            case 'Something went wrong':
              return retryCount < 2
          }
        }

        return retryCount < 3
      },
      refetchIntervalInBackground: false,
      refetchOnWindowFocus: false,
    },
  },
})
